import 'moment/locale/fr';

import { Component, Input } from '@angular/core';
import moment from 'moment';

import { Appointment } from '../../../data/patient/domain/appointment/appointment';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-next-appointment-cell',
  templateUrl: './next-appointment-cell.component.html',
  styleUrls: ['./next-appointment-cell.component.scss'],
})
export class NextAppointmentCellComponent {
  @Input() appointment?: Appointment | undefined;
  @Input() clickable = false;

  public get formattedDate() {
    return moment(this.appointment?.date).format('DD MMMM à HH:mm');
  }
}
